export const isActiveProduct = (product) => {
  return (product.type.code === 'ticket' || product.type.code === 'barcode') && product.active && product.prices
}
